import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { SkeletonTextWrapper } from './TextLoading.elements'

function TextLoading(props) {
  // Destructure
  const { width, height, borderRadius, children, ...rest } = props

  return (
    <SkeletonTextWrapper width={width} height={height} borderRadius={borderRadius} {...rest}>
      {children}
    </SkeletonTextWrapper>
  )
}

// Default Props
TextLoading.defaultProps = {
  width: '',
  height: '',
  borderRadius: '',
  children: '',
}

// Proptypes Validation
TextLoading.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default TextLoading
